import { defineStore } from 'pinia';
import { setService } from '@/api/';
import { useGrayscaleStore } from './grayscale';

// 对象级灰度
const useEntityGrayStore = defineStore('getEntityGrayscaleStore', {
  state: () => ({
    entityGray: 1 //
  }),
  actions: {
    async getEntityGray(params) {
      try {
        const { grayList } = useGrayscaleStore(); // 租户灰度配置

        if (grayList['view_init']) {
          this.entityGray = 1; // 已升级
        } else {
          const json = await setService.getOrgIdByInitType(params); // 对象灰度
          if (!json.error) {
            this.entityGray = json.result; // 对象灰度 0:未升级 1:已升级 2:升级中
          }
        }
      } catch (error) {
        console.log('对象灰度错误', error);
      }
    }
  }
});

export default useEntityGrayStore;
